module.exports = __webpack_public_path__ + "static/img/index_aboutus_3.5df65a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index_aboutus_3.png
// module id = CGyI
// module chunks = 0